import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { 
  FiZap, FiDroplet, FiNavigation, FiCpu, FiShare2, 
  FiCrosshair, FiMonitor, FiCode, FiSmartphone, FiPlay, FiSettings 
} from 'react-icons/fi';

const Services = () => {
  const services = [
    { title: 'Electrification', icon: FiZap },
    { title: 'Hydrogen Fuel Cell Technology', icon: FiDroplet },
    { title: 'Intelligent Vehicles', icon: FiNavigation },
    { title: 'Autonomous Driving', icon: FiCpu },
    { title: 'Machine Learning', icon: FiShare2 },
    { title: 'Artificial Intelligence', icon: FiCrosshair },
    { title: 'AR and VR', icon: FiMonitor },
    { title: 'Software Development', icon: FiCode },
    { title: 'Application Development', icon: FiSmartphone },
    { title: 'AI-Based Games Development', icon: FiPlay },
    { title: 'Automobile Engine Designing', icon: FiSettings },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <section id="technology" className="py-24 bg-charcoal relative border-y border-cyan/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-white mb-4">
              Our Best <span className="text-cyan">Technologies</span> Services
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-cyan to-transparent mx-auto"></div>
          </motion.div>
        </div>

        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
        >
          {services.map((service, index) => (
            <motion.div 
              key={index}
              variants={itemVariants}
              className="bg-navy p-6 rounded-2xl border border-cyan/10 glow-border group cursor-pointer flex flex-col h-full"
            >
              <div className="w-14 h-14 bg-charcoal rounded-xl flex items-center justify-center mb-6 group-hover:bg-cyan/10 transition-colors border border-cyan/5">
                <SafeIcon icon={service.icon} className="w-6 h-6 text-cyan group-hover:text-neon transition-colors" />
              </div>
              <h3 className="text-xl font-heading font-semibold text-white mb-4 group-hover:text-cyan transition-colors">
                {service.title}
              </h3>
              <div className="mt-auto pt-4 flex items-center text-sm text-slate-400 group-hover:text-cyan transition-colors">
                Read More <span className="ml-2 transform group-hover:translate-x-2 transition-transform">→</span>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;